<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectType" });
import { SelectSingle } from "../../../../selects/index.js";
export let key;
export let isDisabled = false;
export let isRequired = true;
const OPTIONS = [{ key: "contact", label: "Standard" }, { key: "invoice", label: "Invoice" }, { key: "warehouse", label: "Warehouse" }];
</script>

<SelectSingle
    bind:key
    label = 'Contact Type'
    name = 'address.contact.type'
    placeholder = 'Select type'
    options = { OPTIONS }
    { isDisabled }
    { isRequired }
/>